<template>
  <div class="input-field filtered-select">
    <div class="select-wrapper-custom">
      <i v-if="icon" class="material-icons prefix">{{ icon }}</i>

      <input
        :id="id"
        type="text"
        v-model="searchTerm"
        class="validate select-search"
        @focus="enterField"
        @blur="onBlur"
        autocomplete="off"
      />

      <!-- Label dinamica come Materialize -->
      <label :for="id" :class="{ active: searchTerm || isFocused }">
        {{ label }}
      </label>

      <ul v-show="dropdownOpen" class="dropdown-content-custom z-depth-2">
        <li
          v-for="opt in filteredOptions"
          :key="opt[valueKey]"
          @click="selectOption(opt[valueKey])"
          class="dropdown-item"
        >
          <img
            v-if="iconKey"
            class="flag-icon"
            :src="flagUrl(opt[iconKey])"
            alt="flag"
          />
          {{ opt[labelKey] }}
        </li>
        <li v-if="filteredOptions.length === 0" class="no-results">
          Nessun risultato
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'

export default {
  name: 'FilteredSelect',
  props: {
    value: String,
    options: { type: Array, required: true },
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'value' },
    iconKey: { type: String, default: null },
    label: { type: String, default: '' },
    icon: { type: String, default: '' },
    id: { type: String, default: 'filtered-select' }
  },
  data () {
    return {
      searchTerm: '',
      dropdownOpen: false,
      isFocused: false
    }
  },
  computed: {
    filteredOptions () {
      const term = this.searchTerm.toLowerCase()
      return this.options.filter(opt =>
        opt[this.labelKey].toLowerCase().includes(term)
      )
    }
  },
  methods: {
    enterField () {
      this.isFocused = true
      this.openDropdown()
    },

    openDropdown () {
      this.dropdownOpen = true
      document.addEventListener('click', this.handleClickOutside)
    },
    closeDropdown () {
      this.dropdownOpen = false
      document.removeEventListener('click', this.handleClickOutside)
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown()
      }
    },

    selectOption (value) {
      this.$emit('input', value)
      this.searchTerm = this.getLabel(value)
      this.closeDropdown()
      this.isFocused = false
      this.$nextTick(() => {
        if (M && M.updateTextFields) M.updateTextFields()
      })
    },

    getLabel (value) {
      const found = this.options.find(opt => opt[this.valueKey] === value)
      return found ? found[this.labelKey] : ''
    },

    flagUrl (iso) {
      return `https://traduzioni.segreteriaorganizzativa.org/images/flags/1x1/${iso.toLowerCase()}.svg`
    },

    onBlur () {
      // 👇 ritardo per permettere il click su un elemento del dropdown
      setTimeout(() => {
        this.isFocused = false
        this.closeDropdown()
      }, 150)
    }
  },
  watch: {
    value (newVal) {
      this.searchTerm = this.getLabel(newVal)
    }
  },
  mounted () {
    if (this.value) {
      this.searchTerm = this.getLabel(this.value)
    }
    if (M && M.updateTextFields) {
      M.updateTextFields()
    }
  }
}
</script>

<style scoped>
.filtered-select {
  position: relative;
}

/* Coerenza con gli input Materialize */
.select-search {
  border: none;
  border-bottom: 1px solid #9e9e9e;
  outline: none;
  width: 100%;
  padding: 8px 0 8px 42px; /* spazio per l'icona prefix */
  background-color: transparent;
  box-sizing: border-box;
  font-size: 1rem;
  color: #212121;
  transition: border-bottom 0.3s ease;
}

.select-search:focus {
  border-bottom: 1px solid #26a69a !important;
  box-shadow: 0 1px 0 0 #26a69a !important;
}

/* Label stile Materialize */
label {
  color: #9e9e9e;
  position: absolute;
  top: 0.8rem;
  left: 0px;
  font-size: 1rem;
  transition: 0.2s ease all;
  pointer-events: none;
}

label.active {
  transform: translateY(-14px) scale(0.8);
  transform-origin: top;
  color: #26a69a;
}

/* Dropdown coerente con Materialize */
.dropdown-content-custom {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  max-height: 250px;
  overflow-y: auto;
  z-index: 999;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  margin-top: 4px;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dropdown-item:hover {
  background-color: #f2f2f2;
}

.flag-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
}

.no-results {
  padding: 10px;
  color: #888;
  text-align: center;
}
</style>
